import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import { StickyState, useStickySearchHeaderState } from '../../hooks/useStickySearchHeaderState';

interface StickyHeaderContext {
  previousStickyStatus?: StickyState;
  stickyState: StickyState;
}
const StickyHeaderContext = createContext<StickyHeaderContext | undefined>(undefined);

export const useStickyHeaderContext = (): StickyHeaderContext => {
  const context = useContext(StickyHeaderContext);
  if (context === undefined) {
    throw new Error('StickyHeaderContext must be used within a StickyHeaderContext.Provider');
  }
  return context;
};

export const StickyHeaderContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [stickyState, previousStickyStatus] = useStickySearchHeaderState();
  return (
    <StickyHeaderContext.Provider value={{ stickyState, previousStickyStatus }}>
      {children}
    </StickyHeaderContext.Provider>
  );
};
